import { http } from '../../core/services/http';
import { transformLoadBusinessType, transformSaveBusinessType } from './transformBusinessType';

export const loadBusinessType = (haulerId: string) =>
  http.get(`/haulerProfile/${haulerId}/businessType`).then(response => transformLoadBusinessType(response.data));

export const saveBusinessType = (haulerId: string, data: any) =>
  http.put(`/haulerProfile/${haulerId}/businessType`, transformSaveBusinessType(data));
